export const Selectcheck = () => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7885 22.0267H7.7734C2.32974 22.0267 0.00390625 19.7009 0.00390625 14.2572V8.24215C0.00390625 2.79849 2.32974 0.472656 7.7734 0.472656H13.7885C19.2321 0.472656 21.558 2.79849 21.558 8.24215V14.2572C21.558 19.7009 19.2321 22.0267 13.7885 22.0267ZM7.7734 1.97643C3.1518 1.97643 1.50768 3.62055 1.50768 8.24215V14.2572C1.50768 18.8788 3.1518 20.523 7.7734 20.523H13.7885C18.4101 20.523 20.0542 18.8788 20.0542 14.2572V8.24215C20.0542 3.62055 18.4101 1.97643 13.7885 1.97643H7.7734Z"
      fill="#6191F2"
    />
  </svg>
);
